<template>
  <div>
    <h2>Finished</h2>
  </div>
</template>

<script>
import QuestionMixin from './QuestionMixin';

export default {
  name: '',

  data() {
    return {
      answer: true,
    };
  },

  mixins: [QuestionMixin],

  mounted() {
    this.$emit('input', this.answer);
  },
};
</script>
